<template>
<div class="columns mt-5 is-variable">
  <div class="column">
    <div class="card" v-for="sound in sounds">
      <div class="card-content">
        <div>
          <span class="icon is-medium has-text-primary">
            <i class="fas fa-lg fa-circle-play"></i>
          </span>
          <span class="title has-text-primary">{{sound.device}}, {{sound.name}}</span>
          <div class="">{{sound.file_name}}</div>
        </div>
        <div>{{sound.date}}</div>
      </div>
      <footer class="card-footer">
        <a class="card-footer-item " disabled>
          <span class="icon has-text-success"><i class="fas fa-download"></i></span>
        </a>
        <a class="card-footer-item is-info" disabled>
          <span class="icon"><i class="fas fa-edit"></i></span>
        </a>

        <DeleteFilesButton
          class="card-footer-item"
          :rounded-edges="true"
          :files-to-delete="[sound.object_key]"
          :only-icon="true"
          :requesting-user="requestingUser"
          @files-deleted="onFilesDeleted">
        </DeleteFilesButton>

      </footer>
    </div>
  </div>
</div>
</template>


<script>
import DeleteFilesButton from '@/components/sounds/bulk-actions/DeleteFilesButton.vue'

export default {
    components: {DeleteFilesButton},
    props: {
        sounds: {type: Object, default: {}},
        requestingUser: {type: String, required: true}
    },
    emits: ['fileDeleted'],
    methods: {
        onFilesDeleted(responses){
            this.$emit('fileDeleted', responses)
        },
    },
}
</script>


<style>
.card {
    margin: 20px;
}
</style>
